import * as React from 'react';

import { cn } from 'cn';

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      data-slot="textarea"
      className={cn(
        'tw:flex tw:field-sizing-content tw:min-h-16 tw:w-full tw:rounded-lg tw:border tw:border-input tw:bg-background tw:px-3 tw:py-2 tw:text-base tw:text-foreground tw:shadow-xs tw:transition-[color,box-shadow] tw:outline-none tw:placeholder:text-muted-foreground tw:hover:border-ring tw:focus-visible:border-ring tw:focus-visible:shadow-[0_0_0_3px_color-mix(in_oklab,var(--ring)_50%,transparent)] tw:disabled:opacity-50 tw:aria-invalid:border-destructive tw:aria-invalid:text-destructive tw:dark:aria-invalid:border-destructive/50',
        className
      )}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
